import { render, staticRenderFns } from "./AttachmentSection.vue?vue&type=template&id=08d76c05&scoped=true&"
import script from "./AttachmentSection.vue?vue&type=script&lang=js&"
export * from "./AttachmentSection.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentSection.vue?vue&type=style&index=0&id=08d76c05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d76c05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
